export default "__VITE_ASSET__CRz$TW5t__"